import { Icon } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import React from "react"
import { useGeolocation } from "../../app-core/_common/providers/geolocation-provider"
import styles from "./PhoneNumber.module.scss"

type Props = {
    className?: string
    showIcon?: boolean
}

const PhoneNumber: React.FC<React.PropsWithChildren<Props>> = ({ className, showIcon = false }) => {
    const geoLocation = useGeolocation()
    const phoneNumber = geoLocation.phone

    if (!phoneNumber) return null

    return (
        <a
            href={`tel:${phoneNumber}`}
            aria-label={`call ${phoneNumber}`}
            data-content-piece="phone"
            className={clsx(styles.phoneNumberLink, className)}
        >
            {showIcon && (
                <Icon name="phone" padding="inline" size="1x" className={styles.phoneNumberIcon} ariaHidden={true} />
            )}
            <span className={styles.phoneNumberLabel}>{phoneNumber}</span>
        </a>
    )
}

export default PhoneNumber
